import React from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

import D3GeoMap from './D3GeoMap';
import jobDemandData from '../data/jobDemandData.json';
import { COUNTY_INDEX } from '../data/countyIndex';

const DemandHoverTooltip = ({ onetSOC, onetTitle, children }) => {
  const demandEntry = jobDemandData.find((item) => item.onetSOC === onetSOC);
  const demandByCounty = demandEntry?.demandByCounty || [];
  const demandData = COUNTY_INDEX.map((countyName, i) => ({
    id: countyName,
    value: demandByCounty[i],
  }));


  return (
    <Tippy
      content={
        <div className='w-[200px] h-[150px] overflow-hidden'>
          <D3GeoMap key={onetSOC} demandData={demandData} />
        </div>
      }
      theme="light"
      interactive={true}
      delay={[500, 0]}         // no hide delay
      placement="left-end"
      arrow={true}
      offset={[50, 5]}
      appendTo={() => document.body}
      hideOnClick={true}
     
    >
      <span>
        {children}
      </span>
    </Tippy>
  );
};

export default DemandHoverTooltip;